function classNames(...classes) {return classes.filter(Boolean).join(' ')}
export const FlatBadge = ({text, color}) => {
    return (
      <>
        <span className={classNames(`inline-flex items-center rounded-md ${color.background} px-2 py-1 text-xs font-normal ${color.text}`)}>
          {text}
        </span>
      </>
    )
  }